import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { delayRetrieveRecords } from '../store/actions/search';
import {
  selectInvestmentType,
  selectTransactionType,
  selectPropertyType,
  changeAddressFilter
} from '../store/actions/query';

import AddressFilter from './address_filter';
import PropertyFilter from './property_filter';

import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';
import FilterButton from 'components/search_sidebar/filter_button';
import { getTransactionTypes, getPropertyTypes, getInvestmentTypes } from '../store/selectors/static';
import {
  getSelectedInvestmentTypes,
  getSelectedTransactionTypes,
  getSelectedPropertyTypes
} from '../store/selectors/query';

export class Filters extends React.Component {
  static propTypes = {
    delayRetrieveRecords: PropTypes.func.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    propertyTypes: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    selectedPropertyTypes: PropTypes.array.isRequired,
    selectedTransactionTypes: PropTypes.array.isRequired,
    transactionTypes: PropTypes.array.isRequired,

    onInvestmentTypeChange: PropTypes.func.isRequired,
    onPropertyTypeChange: PropTypes.func.isRequired,
    onTransactionTypeChange: PropTypes.func.isRequired
  }

  handleChange = (e, callBack) => {
    const { delayRetrieveRecords } = this.props;
    callBack(e.target.value, e.target.checked);
    delayRetrieveRecords();
  }

  render() {
    return (
      <React.Fragment>
        {this.renderTransactionTypes()}
        {this.renderPropertyTypes()}
        {this.renderInvestmentTypes()}
        <PropertyFilter />
        <AddressFilter />
      </React.Fragment>
    );
  }

  renderTransactionTypes() {
    const { selectedTransactionTypes, transactionTypes, onTransactionTypeChange } = this.props;

    return (
      <FilterButton
        filtersApplied={selectedTransactionTypes.length > 0}
        label="Transaction Type"
        name="transaction-types"
      >
        <FilterCheckboxGroup
          options={transactionTypes}
          selected={selectedTransactionTypes}
          onChange={e => this.handleChange(e, onTransactionTypeChange)}
        />
      </FilterButton>
    );
  }

  renderPropertyTypes() {
    const { selectedPropertyTypes, propertyTypes, onPropertyTypeChange } = this.props;

    return (
      <FilterButton
        filtersApplied={selectedPropertyTypes.length > 0}
        label="Property Type"
        name="property-types"
      >
        <FilterCheckboxGroup
          options={propertyTypes}
          selected={selectedPropertyTypes}
          onChange={e => this.handleChange(e, onPropertyTypeChange)}
        />
      </FilterButton>
    );
  }

  renderInvestmentTypes() {
    const { selectedInvestmentTypes, investmentTypes, onInvestmentTypeChange } = this.props;

    return (
      <FilterButton
        filtersApplied={selectedInvestmentTypes.length > 0}
        label="Investment Type"
        name="investment-types"
      >
        <FilterCheckboxGroup
          options={investmentTypes}
          selected={selectedInvestmentTypes}
          onChange={e => this.handleChange(e, onInvestmentTypeChange)}
        />
      </FilterButton>
    );
  }
}

const mapStateToProps = state => ({
  investmentTypes: getInvestmentTypes(state),
  transactionTypes: getTransactionTypes(state),
  propertyTypes: getPropertyTypes(state),
  selectedInvestmentTypes: getSelectedInvestmentTypes(state),
  selectedTransactionTypes: getSelectedTransactionTypes(state),
  selectedPropertyTypes: getSelectedPropertyTypes(state)
});

const mapDispatchToProps = {
  delayRetrieveRecords,
  onAddressFilterChange: changeAddressFilter,
  onInvestmentTypeChange: selectInvestmentType,
  onTransactionTypeChange: selectTransactionType,
  onPropertyTypeChange: selectPropertyType
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
